<template>
  <div
    v-if="market"
    class="inventory-page-sidebar card-dark"
  >
    <div
      v-if="data?.data?.latestManualCheckedInventory?.count"
      class="inventory-page-sidebar-top"
    >
      <div class="f fs mb8">
        <svg
          height="32"
          width="32"
        >
          <use xlink:href="/icons/sprite.svg#i-user" />
        </svg>
        <span class="top-count">{{ count }}</span>
      </div>
      <p>{{ $t("inventory.recent_count") }}</p>
    </div>
    <div class="users-list">
      <div
        v-for="(item, i) in items"
        :key="item?.steamid64"
        class="users-list-item ovh"
      >
        <!--        <nuxt-link :to="localePath(`/inventory/${item?.steamid64}`)"> -->
        <img
          :src="getImageFromProxy(item?.avatar_url?.replace(/\.(jpe?g)$/i, '_full.$1'), '100:100')"
          alt=""
          class="user-avatar w40"
        >
        <!--        </nuxt-link> -->
        <div class="w100p ovh">
          <div class="f fb fg">
            <div class="w100p">
              <nuxt-link
                :to="localePath(`/inventory/${item?.steamid64}`)"
                class="user-name ell"
              >
                {{ item?.persona_name }}
              </nuxt-link>
              <!--              <p class="user-name ell"> -->
              <!--                {{ item?.persona_name }} -->
              <!--              </p> -->
              <div class="f w100p">
                <UiPrice
                  :decimal="0"
                  :price="getTotal(item)"
                />
                <UiDateAgo :date="item?.date" />
              </div>
            </div>
          </div>
          <div
            v-show="i !== 9"
            class="hr"
          />
        </div>
      </div>
    </div>
    <button
      v-if="!user"
      class="btn-primary btn-violet w-100 mt32"
      @click="login"
    >
      {{ $t("inventory.check_my_btn") }}
    </button>
    <nuxt-link
      v-else
      :to="localePath(`/inventory/${user?.steamid64}`)"
      class="btn btn-primary btn-violet w-100 mt32 tac"
    >
      {{ $t("inventory.check_my_btn") }}
    </nuxt-link>
  </div>
</template>

<script lang="ts" setup>
import type { LatestManualCheckedInventoryItem } from '~/graphql/generated/schema-types';
import { onBeforeUnmount, ref, watch, watchEffect } from 'vue';
import { useStore } from '~/store';

const props = withDefaults(
  defineProps<{
    market?: string
  }>(),
  {
    market: 'waxpeer',
  },
);
const store = useStore();
const user = computed(() => store.user);
const localePath = useLocalePath();
const config = useRuntimeConfig();
const url = config.public.baseUrlV2;

function login() {
  return (document.location = `${url}/auth/steam`);
}

const recentInventoriesCount = ref<number>(0);
const recentInventoriesItems = ref<LatestManualCheckedInventoryItem[] | any[]>([]);
const count = computed(() => recentInventoriesCount.value);
const items = computed(() => recentInventoriesItems.value);

const { data, refresh } = useAsyncData('latestCheckedInventories', async () => {
  try {
    const response = await getLatestCheckedInventories(props.market);
    recentInventoriesCount.value
        = response.data.latestManualCheckedInventory.count;
    recentInventoriesItems.value
        = response.data.latestManualCheckedInventory.checks;
    return response;
  } catch (error) {
    console.error('Ошибка при загрузке инвентаря:', error);
  }
});

watch(
  () => data.value?.data?.latestManualCheckedInventory,
  (newValue) => {
    if (newValue) {
      recentInventoriesCount.value = newValue.count;
      recentInventoriesItems.value = newValue.checks;
    }
  },
  { immediate: true },
);

const { $socket } = useNuxtApp();

function subscribeToSocket() {
  if (!$socket)
    return;

  $socket.on('inventory-recent', (data: any) => {
    recentInventoriesCount.value = data.count;
    recentInventoriesItems.value = data.checks;
    // if (data.checks) {
    //   const newItems = data.checks.filter((newItem: any) => {
    //     const existingItem = recentInventoriesItems.value.find((item: any) =>
    //       item.steamId64 === newItem.steamId64
    //     );

    //     return !existingItem || existingItem.date !== newItem.date;
    //   });

    //   if (newItems.length > 0) {
    //     recentInventoriesItems.value = [
    //       ...newItems,
    //       ...recentInventoriesItems.value.slice(0, -newItems.length)
    //     ];
    //   }
    // }
  });
}

function getTotal(item: any) {
  if (!item)
    return;
  if (item.inventory_value) {
    return item.inventory_value;
  }
  if (item.markets[props.market]) {
    return item.markets[props.market]?.inventory_value;
  }
  return 0;
}

function unsubscribeFromSocket() {
  if (!$socket)
    return;
  $socket.off('inventory-recent');
}

watchEffect(() => {
  if ($socket) {
    subscribeToSocket();
  }
});
watchEffect(() => {
  if (props.market) {
    refresh();
  }
});

onBeforeUnmount(() => {
  unsubscribeFromSocket();
});
</script>

<style lang="scss" scoped>
.inventory-page {
  &-sidebar {
    width: 48%;

    &-top {
      margin-bottom: 32px;

      svg {
        color: var(--accent-primary);
        display: inline-block;
        margin-right: 8px;
      }

      .top-count {
        font-size: 32px;
        font-weight: 600;
        color: var(--surfaces-on-surface);
      }
    }

    .users-list {
      display: flex;
      flex-direction: column;
      gap: 20px;

      &-item {
        display: flex;
        align-items: flex-start;
        width: 100%;
        position: relative;

        &:hover .user-avatar {
          transform: scale(1.1);
        }

        .user-avatar {
          width: 40px;
          height: 40px;
          object-fit: cover;
          border-radius: 50%;
          margin-right: 12px;
          margin-top: 6px;
          transition: transform 0.3s;
        }

        .user-name {
          margin-bottom: 4px;
          display: inline-block;

          &:after {
            content: "";
            position: absolute;
            inset: 0;
          }
        }

        .price {
          font-size: 16px;
          font-weight: 600;
          color: var(--surfaces-on-surface);
        }

        .hr {
          margin-top: 20px;
        }
      }
    }

    @media screen and (max-width: 989px) {
      width: 100%;
      max-width: 100%;
      min-width: 100%;
    }
  }
}
</style>
